<template>
  <vs-input
    :value="value"
    @input="handleInput"
    :class="iClass"
    v-if="editable"
    style="width: 100%"
    :placeholder="iPlaceholder"
    :aria-label="accessibleLabel"
  />
  <p :class="pClass" v-else>{{ value ? value : 'N/A' }}</p>
</template>

<script>
export default {
  // `label` names the field for assistive tech (WCAG SC 1.3.1 / 4.1.2). Pass the question
  // text where it is known; the fallback at least identifies what the control is for.
  props: ['value', 'editable', 'pclass', 'iclass', 'placeholder', 'label'],
  data() {
    return {
      login_type: localStorage.getItem('login_type'),
    };
  },
  computed: {
    pClass() {
      if (typeof this.$props.pclass !== 'undefined') {
        return this.$props.pclass;
      } else {
        return 'my-5';
      }
    },
    iClass() {
      if (typeof this.$props.iclass !== 'undefined') {
        return this.$props.iclass;
      } else {
        return 'mb-3';
      }
    },
    // With no explicit label or placeholder, utils/a11yDom.js names the control from the
    // question text that precedes it.
    accessibleLabel() {
      return this.$props.label || this.$props.placeholder || null;
    },
    iPlaceholder() {
      if (typeof this.$props.placeholder !== 'undefined') {
        return this.$props.placeholder;
      } else {
        return '';
      }
    },
  },
  methods: {
    handleInput(e) {
      //console.log(e);
      this.$emit('input', e);
    },
  },
};
</script>
